module.exports = __webpack_public_path__ + "static/1-7bb196c0ec94aa3d154a709dc3d1d4b9.jpg";